import * as mutationTypes from './mutationTypes'

export default {
  [mutationTypes.AREA_LIST_UPDATED](state, payload) {
    state.areaList = payload
  },
  [mutationTypes.AREA_TEMATICA_LIST_UPDATED](state, payload) {
    state.areaTematicaList = payload
  },
  [mutationTypes.REGIONE_LIST_UPDATED](state, payload) {
    state.regioneList = payload
  },
  [mutationTypes.AREA_RISERVATA_ENUM_LIST_UPDATED](state, payload) {
    state.areaRiservataEnumList = payload
  },
  [mutationTypes.TRAINING_COURSE_TYPES_LIST_UPDATED](state, payload) {
    state.trainingCourseTypesList = payload
  },
}
